module.exports = __webpack_public_path__ + "img/weddingRingsMorningGlow-emotion-01.4ce646e.webp";